import React from 'react'
import styles from './index.module.css'
import Button from '../../../components/Button'
import Select from '../../../components/ModalInputs/Select'

const Index = ({ params, handleChange, handleGetData, schoolYears }) => {
    return (
        <div className={styles.container}>
            <div className={styles.inputsRow}>
                <div className={styles.container_select}>
                    <Select
                        value={params.school_year}
                        name='school_year'
                        label='Год поступления'
                        onChange={(e) => handleChange(e.target.name, Number(e.target.value))}>
                        {schoolYears
                            ?.map(el => <option key={el.xp_key} value={el.xp_key}>{el.name}</option>)}</Select>
                </div>

                <Button className={styles.button} onClick={() => handleGetData()}>Обновить</Button>
            </div>
        </div>
    )
}

export default Index